module.exports = __webpack_public_path__ + "img/bell.46ee56a1.svg";